<template>
    <div class="loginPage">
        <v-container class="custom-container bg-register forgot-password">
            <v-row no-gutters>
                <v-col md="12">
                    <div class="top-bar-register">
                        <div class="logo-wrapper">
                            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
                        </div>
                        <LanguageMenu></LanguageMenu>
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center" no-gutters>
                <v-col md="7" sm="9" cols="11">
                    <h3 class="justify-center">Forget Password</h3>
                    <div class="deposit-form">
                        <v-stepper v-model="el" class="password-stepper forgot-password-stepper">
                            <v-stepper-header>
                                <v-stepper-step :complete="el > 1" step="1" color="greenMain">
                                    Step 1
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="el > 2" step="2" color="greenMain">
                                    Step 2
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="3" color="#708AA7">Reset Password
                                </v-stepper-step>


                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-card class="deposit-form pl-0 pt-0 mb-3"
                                        :color="$vuetify.theme.dark ? '#172233' : '#ffffff'">
                                        <v-row dense>
                                            <v-col cols="12" sm="12" md="12">
                                                <fieldset class="forget-fieldset">
                                                    <legend>Enter your email</legend>
                                                    <v-text-field type="email" v-model="email"
                                                        placeholder="Ex: abc@gmail.com" single-line solo hide-details
                                                        class="custom-select" autocomplete="false"
                                                        aria-autocomplete="none"></v-text-field>
                                                </fieldset>
                                                <span v-if="error.emailError" class="error-message">
                                                    {{ error.emailError }}
                                                </span>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-btn width="100" class="text-capitalize btn-account" color="greenMain"
                                                    tile elevation="0" @click="sentOTP" :loading="loading"
                                                    :disabled="loading">
                                                    Send OTP
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <v-card class="deposit-form pl-0 pt-0"
                                        :color="$vuetify.theme.dark ? '#172233' : '#ffffff'">
                                        <v-row>
                                            <v-col style="position: relative">
                                                <v-card-title> Enter OTP </v-card-title>
                                                <v-card-text>
                                                    <p class="bg-timer">
                                                        Check Your Email {{ email }} & input OTP
                                                        here. Please be advised that you have
                                                        <span class="text-red">{{ formattedTime }}</span> minutes
                                                        remaining to
                                                        authorize your password change request.
                                                    </p>
                                                </v-card-text>
                                                <fieldset class="forget-fieldset">
                                                    <legend>Enter OTP</legend>
                                                    <v-text-field label="Enter Here" single-line solo hide-details
                                                        class="custom-select" type="number" inputmode="numeric"
                                                        pattern="[0-9]*" v-model="forgetPassOTP"></v-text-field>
                                                </fieldset>
                                                <v-card-actions class="pa-0">
                                                    <v-btn v-if="formattedTime === '0:00'"
                                                        class="text-capitalize btn-account mr-2" width="100"
                                                        color="greenMain" tile elevation="0" @click.prevent="resendOTP">
                                                        Resend OTP
                                                    </v-btn>
                                                    <v-btn v-if="formattedTime !== '0:00'"
                                                        class="text-capitalize btn-account mr-2" width="100"
                                                        color="greenMain" tile elevation="0"
                                                        @click.prevent="updateStepper(1)">
                                                        Back
                                                    </v-btn>
                                                    <v-btn v-if="formattedTime !== '0:00'"
                                                        class="text-capitalize btn-account" width="100"
                                                        color="greenMain" tile elevation="0" :loading="loading"
                                                        :disabled="loading" @click.prevent="handleCodeVerify">
                                                        Verify OTP
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <v-card class="deposit-form pl-0 pt-0 password-field" max-width="612px"
                                        :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
                                        <v-row>
                                            <v-col>
                                                <v-card-title> Enter New Password </v-card-title>
                                                <fieldset>
                                                    <legend>New Password</legend>
                                                    <v-text-field label="Enter Here" v-model="new_password"
                                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'
                                                            " :type="show1 ? 'text' : 'password'" counter
                                                        @click:append="show1 = !show1" single-line solo hide-details
                                                        class="custom-select"></v-text-field>
                                                </fieldset>
                                                <div class="tick-mark justify-start">
                                                    <span>
                                                        <v-icon small :class="hasMinimumLength
                                                            ? 'text--green'
                                                            : 'text--ash'
                                                            ">mdi mdi-check</v-icon>8 Characters
                                                    </span>
                                                    <span>
                                                        <v-icon small :class="hasLowerCase
                                                            ? 'text--green'
                                                            : 'text--ash'
                                                            ">mdi mdi-check</v-icon>1 Lowercase
                                                    </span>
                                                    <span>
                                                        <v-icon small :class="hasUpperCase
                                                            ? 'text--green'
                                                            : 'text--ash'
                                                            ">mdi mdi-check</v-icon>1 Uppercase
                                                    </span>
                                                    <span>
                                                        <v-icon small :class="hasDigit
                                                            ? 'text--green'
                                                            : 'text--ash'
                                                            ">mdi mdi-check</v-icon>1 Digit
                                                    </span>
                                                    <span>
                                                        <v-icon small :class="hasSpecialCharacter
                                                            ? 'text--green'
                                                            : 'text--ash'
                                                            ">mdi mdi-check</v-icon>1 Special Character
                                                    </span>
                                                </div>
                                                <fieldset>
                                                    <legend>Confirm Password</legend>
                                                    <v-text-field label="Re-type new password"
                                                        v-model="confirm_password" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'
                                                            " :type="show2 ? 'text' : 'password'" counter
                                                        @click:append="show2 = !show2" single-line solo hide-details
                                                        class="custom-select" @copy="onCopy"
                                                        @paste="onPaste"></v-text-field>
                                                </fieldset>
                                                <v-card-actions class="pa-0">
                                                    <v-btn width="130" class="ma-0 text-capitalize btn-account"
                                                        color="greenMain" tile elevation="0"
                                                        :disabled="!allConditionsMet" @click.prevent="handlePassReset">
                                                        Save Password
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row justify="center" class="mb-5">
                <v-col md="5">
                    <p class="emailLink text-center">
                        <strong>High Risk Investment Warning:</strong> Trading Leveraged
                        Products such as Forex and Derivatives may not be suitable for all
                        investors as they carry a high degree of risk to your capital. Please
                        ensure that you fully understand the risks involved, taking into
                        account your investments objectives and level of experience, before
                        trading, and if necessary, seek independent advice.
                    </p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { isValidEmail } from "@/_helpers/validate";
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { AUTHENTICATION__ACTIONS, PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { AUTHENTICATION__MUTATIONS } from "@/store/mutation-types";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    components: { LanguageMenu },
    data() {
        return {
            show1: false,
            show2: false,
            loading: false,
            password: "",
            email: "",
            forgetPassOTP: null,
            error: {
                emailError: null,
            },
            new_password: "",
            confirm_password: "",
            countdownTime: 120,
            hasMinimumLength: false,
            hasLowerCase: false,
            hasUpperCase: false,
            hasDigit: false,
            hasSpecialCharacter: false,
        };
    },
    computed: {
        ...mapState("authentication", ["forgetPasswordOTP", "el"]),
        ...mapState("publicinfo", ["info"]),

        formattedTime() {
            const minutes = Math.floor(this.countdownTime / 60);
            const seconds = this.countdownTime % 60;
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        },

        allConditionsMet() {
            return (
                this.hasMinimumLength &&
                this.hasLowerCase &&
                this.hasUpperCase &&
                this.hasDigit &&
                this.hasSpecialCharacter
            );
        },

        logoSrc() {
            return this.info?.logo_url || null;  // Changed from generalInfo to info
        },

        companyName() {
            return this.info?.company_name || "Forex Crm";  // Changed from generalInfo to info
        },

        logoWidth() {
            return this.info?.logo_width || "50px";  // Changed from generalInfo to info
        },

        logoHeight() {
            return this.info?.logo_height || "50px";  // Changed from generalInfo to info
        }
    },

    watch: {
        new_password: function () {
            this.hasMinimumLength = this.new_password.length >= 8;
            this.hasLowerCase = /.*[a-z].*/.test(this.new_password);
            this.hasUpperCase = /.*[A-Z].*/.test(this.new_password);
            this.hasDigit = /.*\d.*/.test(this.new_password);
            this.hasSpecialCharacter = /.*[@$!%*#?&^_-].*/.test(
                this.new_password
            );
        },
    },

    methods: {
        ...mapMutations("authentication", {
            FORGETPASSWORDCODE: AUTHENTICATION__MUTATIONS.FORGETPASSWORDCODE,
            UPDATESTEPPER: AUTHENTICATION__MUTATIONS.UPDATESTEPPER,
        }),

        ...mapActions("authentication", [
            AUTHENTICATION__ACTIONS.SENTFORGETPASSOTP,
            AUTHENTICATION__ACTIONS.FORGETPASSWORDCODE,
            AUTHENTICATION__ACTIONS.FORGETPASSWORDRESET,
        ]),

        ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),

        async sentOTP() {
            const { email } = this;

            if (!email) {
                this.error.emailError = "Please provide a valid email address";
                return;
            }

            if (!isValidEmail(email)) {
                this.error.emailError = `${email} is not a valid email address`;
                return;
            }

            this.loading = true;
            try {
                await this[AUTHENTICATION__ACTIONS.SENTFORGETPASSOTP]({ email });
            } catch (error) {
                console.error("Error:", error);
            } finally {
                this.loading = false;
            }
        },


        async handleCodeVerify() {
            try {
                this.loading = true;
                await this[AUTHENTICATION__ACTIONS.FORGETPASSWORDCODE]({ otp: this.forgetPassOTP });
                this.forgetPassOTP = null;
            } catch (error) {
                console.error("Code verification error:", error?.message || error);
            } finally {
                this.loading = false;
            }
        },


        startCountdown() {
            const timerInterval = setInterval(() => {
                if (this.countdownTime > 0) {
                    this.countdownTime -= 1;
                } else {
                    clearInterval(timerInterval);
                }
            }, 1000);
        },

        handlePassReset() {
            const data = {
                email: this.email,
                new_password: this.new_password,
                confirm_password: this.confirm_password,
            };
            this[AUTHENTICATION__ACTIONS.FORGETPASSWORDRESET](data);
        },

        updateStepper(value) {
            this.UPDATESTEPPER(value);
        },

        onCopy(event) {
            event.preventDefault();
        },

        onPaste(event) {
            event.preventDefault();
        },

        resendOTP() {
            this.sentOTP();
            this.countdownTime = 120;
        },
    },

    async mounted() {
        try {
            this.startCountdown();
            this.UPDATESTEPPER(1);
            await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
